module.exports = __webpack_public_path__ + "img/element-icons-logo-wavve-original.0d64a871.svg";